/**
 * In-app message limits — spec `dev/projects/in-app-messages.md` §Limits.
 * The shared schema enforces the first five; the API enforces the last two at publish.
 */
export const LIMITS = {
  bodyChars: 500,
  titleChars: 80,
  actionLabelChars: 40,
  groupsPerAudience: 5,
  conditionsPerGroup: 10,
  liveMessagesPerApp: 20,
  snapshotBytes: 100 * 1024,
} as const;
